import Vue from "vue";
import api from "@/app";

Vue.config.devtools = true;

declare global {
  interface Window {
    z: any;
  }
}

if (window.z === undefined) {
  window.z = {};
}

window.z.operatersSidebarApi = api;

